import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated, getUser } from './utils/api';
import Login from './pages/Login';
import AdminPanel from './pages/AdminPanel';
import AdminReports from './pages/AdminReports';
import AgencyPortal from './pages/AgencyPortal';
import ClientPortal from './pages/ClientPortal';
import Checkout from './pages/Checkout';
import Landing from './pages/Landing';

function ProtectedRoute({ children, allowedRoles }) {
  if (!isAuthenticated()) return <Navigate to="/login" />;
  const user = getUser();
  if (allowedRoles && !allowedRoles.includes(user?.role)) return <Navigate to="/login" />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/admin" element={<ProtectedRoute allowedRoles={['admin']}><AdminPanel /></ProtectedRoute>} />
      <Route path="/admin/reports" element={<ProtectedRoute allowedRoles={['admin']}><AdminReports /></ProtectedRoute>} />
      <Route path="/agency" element={<ProtectedRoute allowedRoles={['agency']}><AgencyPortal /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute allowedRoles={['client']}><ClientPortal /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
